import { apiFetch } from "@/lib/api/fetcher";

const ACTIVE_SUBSCRIPTION_PATH = "/ott/v1/ott/subscription-plan/active";

type ActiveSubscriptionResponse = {
  success?: boolean;
  data?: {
    status?: string;
  };
};

export type PiSubscriptionStatus = { isActive: boolean };

/**
 * Mirrors gcms-admin's `fetchPiWebActiveSubscriptionStatus` (src/widgets/pi-web/subscription-plans.ts):
 * ACTIVE, or any other status that still has a subscription record, sends the visitor to the Pi
 * home. CANCELLED/EXPIRED, no subscription record, and failed requests (e.g. 400 for a visitor who
 * never subscribed) all send them to the subscription page instead.
 */
export async function fetchActiveSubscriptionStatus(): Promise<PiSubscriptionStatus> {
  try {
    const payload = await apiFetch<ActiveSubscriptionResponse>(
      ACTIVE_SUBSCRIPTION_PATH,
    );

    const status = (
      payload.success ? payload.data?.status : undefined
    )?.toUpperCase();

    return {
      isActive:
        Boolean(status) && status !== "CANCELLED" && status !== "EXPIRED",
    };
  } catch {
    return { isActive: false };
  }
}
